import React, { useState, createContext, useContext } from "react";
import { languageOptions, dictionaryList } from "../languages";

const runtimeLocale = new Intl.NumberFormat().resolvedOptions().locale;
const initialLanguage = runtimeLocale.includes("de") ? "de" : "en";

export const LanguageContext = createContext({
  language: initialLanguage,
  dictionary: dictionaryList[initialLanguage],
});

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState("en");

  const provider = {
    language,
    dictionary: dictionaryList[language],
    onLanguageChange: (selected) => {
      const newLanguage = languageOptions[selected] ? selected : "en";
      setLanguage(newLanguage);
      window.localStorage.setItem("rcml-lang", newLanguage);
    },
  };

  return (
    <LanguageContext.Provider value={provider}>
      {children}
    </LanguageContext.Provider>
  );
}

export function Text({ tid }) {
  const { dictionary } = useContext(LanguageContext);
  return dictionary[tid] || tid;
}
